import { subscribe } from '../../common/errors/sagas';
import { subscribeConfiguration } from '../../common/saveconfiguration/sagas';
import { notificationError, notificationInfo } from '../../common/errors/notificationTypes';

const pre = 'CSADRILLDOWN/';

export const FETCH_CSADRILLDOWN_REQUESTED = `${pre}FETCH_CSADRILLDOWN_REQUESTED`;
export const FETCH_CSADRILLDOWN_SUCCEEDED = `${pre}FETCH_CSADRILLDOWN_SUCCEEDED`;
export const FETCH_CSADRILLDOWN_FAILED = `${pre}FETCH_CSADRILLDOWN_FAILED`;
export const CSADRILLDOWN_LOADED = `${pre}CSADRILLDOWN_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_CSADRILLDOWN_COLUMNS = `${pre}SET_CSADRILLDOWN_COLUMNS`;
export const TOGGLE_ROW_EXPANDED = `${pre}TOGGLE_ROW_EXPANDED`;
export const SET_ALL_EXPANDED = `${pre}SET_ALL_EXPANDED`;
export const REFRESH_DATA = `${pre}REFRESH_DATA`;
export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const SET_DRILLDOWN_FILTERS = `${pre}SET_DRILLDOWN_FILTERS`;
export const FETCH_CSADRILLDOWNS_RETURNED_EMPTY = `${pre}FETCH_CSADRILLDOWNS_RETURNED_EMPTY`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;
export const FETCH_DEFAULT_CONFIG_FAILED = `${pre}FETCH_DEFAULT_CONFIG_FAILED`;
export const REFRESH_CSA_DRILLDOWN = `${pre}REFRESH_CSA_DRILLDOWN`;

subscribe(FETCH_CSADRILLDOWN_FAILED, 'Failed to fetch CSADrilldowns', notificationError);
subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribe(FETCH_CSADRILLDOWNS_RETURNED_EMPTY, 'Fetch CSV Drilldowns returned an empty list', notificationInfo);
subscribe(FETCH_DEFAULT_CONFIG_FAILED, 'Failed to fetch the default configuration', notificationInfo);
subscribeConfiguration(SET_CSADRILLDOWN_COLUMNS, 'CSADrilldown');

export const refreshCsaDrilldown = () => ({
    type: REFRESH_CSA_DRILLDOWN
});

export const setDefaultConfig = columns => ({
    type: SET_DEFAULT_CONFIG,
    columns
});

export const setDrilldownFilters = (csa, date, counterparty) => ({
    type: SET_DRILLDOWN_FILTERS,
    csa,
    date,
    counterparty
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const setCsaDrilldownColumns = data => ({
    type: SET_CSADRILLDOWN_COLUMNS,
    data
});

export const fetchCsaDrilldownRequested = () => ({
    type: FETCH_CSADRILLDOWN_REQUESTED
});

export const fetchCsaDrilldownSucceeded = (data, serverFilters) => ({
    type: FETCH_CSADRILLDOWN_SUCCEEDED,
    data,
    serverFilters
});

export const fetchCsaDrilldownsReturnedEmpty = error => ({
    type: FETCH_CSADRILLDOWNS_RETURNED_EMPTY,
    error
});

export const fetchCsaDrilldownFailed = error => ({
    type: FETCH_CSADRILLDOWN_FAILED,
    error
});

export const fetchDefaultConfigFailed = error => ({
    type: FETCH_DEFAULT_CONFIG_FAILED,
    error
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});

export const csaDrilldownsLoaded = () => ({
    type: CSADRILLDOWN_LOADED
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const toggleRowExpanded = data => ({
    type: TOGGLE_ROW_EXPANDED,
    data
});

export const setAllExpanded = data => ({
    type: SET_ALL_EXPANDED,
    data
});

export const refreshData = () => ({
    type: REFRESH_DATA
});
